import React, { useCallback } from 'react'
import SelectInput from 'components/common/Inputs/SelectInput'
import NestedSelectInput from 'components/common/Inputs/NestedSelectInput'
import { FIELD_TRIGGER_INPUT_VALUES } from 'constants/jobsTriggers'
import { Input, INPUT_TYPES } from '../TriggerInputs/TriggerInputs.types'
import {
  FormattedTriggerInputOption,
  TriggerInputsSelectProps,
} from './TriggerInputsSelect.types'

const TriggerInputsSelect = ({
  isTaskSelected,
  isDisabled,
  label,
  onChangeFormValue,
  formattedTriggerInputsList,
  selectedInputs,
  inputs,
  inputValues,
  hasClearOption = false,
}: TriggerInputsSelectProps) => {
  const onInputSelect = (value: number[]) =>
    onChangeFormValue(
      value.map(input => {
        const currentValue =
          inputValues?.find(
            ({ input: selectedInput }: { input: number }) =>
              selectedInput === input,
          )?.values || []

        return {
          input: +input,
          values: selectedInputs.includes(input) ? currentValue : [],
        }
      }),
      FIELD_TRIGGER_INPUT_VALUES,
    )

  const filterInputs = useCallback(
    inputsList =>
      inputsList.filter(
        ({ type }: FormattedTriggerInputOption | Input) =>
          type === INPUT_TYPES.SELECT || type === INPUT_TYPES.BOOLEAN,
      ),
    [],
  )

  return isTaskSelected ? (
    <SelectInput
      disabled={isDisabled}
      hasClearOption={hasClearOption}
      multiple
      hasSearchField
      label={label}
      options={filterInputs(inputs) || []}
      value={selectedInputs}
      onChange={onInputSelect}
      hasSelectAllOption
    />
  ) : (
    <NestedSelectInput
      disabled={isDisabled}
      hasClearOption={hasClearOption}
      multiple
      hasSearchField
      hasSelectAllOption
      label={label}
      options={formattedTriggerInputsList.map(input => ({
        ...input,
        options: filterInputs(input.options),
      }))}
      value={selectedInputs}
      onChange={onInputSelect}
    />
  )
}

export default TriggerInputsSelect
